module.exports = __webpack_public_path__ + "img/image9.706930b8.jpg";